import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'FieldSelect';

const classes = {
  bgHover: `${PREFIX}-bgHover`
};

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  [`& .${classes.bgHover}`]: {
    '&:hover': {
      background: theme.palette.primary.light
    }
  }
}));

const getItem = (item: any) => {
  return (
    <MenuItem key={item.key} value={item.key} data-testid="fieldSelectItem">
      {item.label}
    </MenuItem>
  );
};

const getGroupItems = (item: any) => {
  return <optgroup label={item.label}>{item.subfields.map(getItem)}</optgroup>;
};
const FieldSelect = ({ items, setField, selectedKey }: any) => {
  const onChangeHandler = (e: any) => {
    setField(e.target.value);
  };

  return (
    <StyledFormControl variant="outlined" fullWidth data-testid="fieldSelectForm">
      <Select
        className={classes.bgHover}
        value={selectedKey || ''}
        displayEmpty
        onChange={onChangeHandler}
        inputProps={{
          name: 'field',
          id: 'field-select',
          'data-testid': 'property-selector'
        }}
      >
        <MenuItem value="" disabled>
          Select Property
        </MenuItem>
        {items.map((item: any) => (item.type === '!group' ? getGroupItems(item) : getItem(item)))}
      </Select>
    </StyledFormControl>
  );
};

export default FieldSelect;
